import { Form, FormProps } from 'antd';
import { t } from 'i18next';
import React from 'react';
import ExtraTab from 'src/app/components/ExtraTabcomponent/ExtraTab';
import styles from 'src/app/components/FormComponent/FormComponent.module.scss';
import { formHelper } from 'src/app/helpers';
import { SaveIcon } from 'src/icons';

interface IFormComponentProps {
  children: React.ReactNode;
  options?: FormProps;
  hasSaveButton?: boolean;
  onClick?: () => void;
  onFinish?: () => void;
  onFinishFailed?: () => void;
  extraButton?: React.ReactNode;
  saveButtonText?: string;
  saveButtonDisabled?: boolean;
}

/* 
This component refers to global form structure.
It takes form items as children and show them in specified layout.
It has save button prop to show pre-arranged save button.
Also it may have extra button with extraButton prop.
*/
const FormComponent: React.FC<IFormComponentProps> = ({
  children,
  options,
  hasSaveButton,
  extraButton,
  saveButtonText,
  saveButtonDisabled,
}) => {
  const handleFormSubmit = (e: any) => {
    e.stopPropagation();
    if (options?.form) {
      formHelper.submitForm(options.form);
    }
  };

  return (
    <>
      <Form
        className={styles.formContainer}
        preserve={false}
        id="form-component"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        labelAlign="left"
        colon={false}
        scrollToFirstError
        {...options}
        // If field is empty do not send it to the backend intead of sending it with value of empty string
        onValuesChange={(value, values) => {
          Object.entries(value).forEach(([key, formValue]) => {
            if (formValue === '') {
              options?.form?.setFieldValue(key, undefined);
            }
          });
          if (options?.onValuesChange) options?.onValuesChange(value, values);
        }}
      >
        {children}
      </Form>

      {hasSaveButton || extraButton ? (
        <div className={styles.buttonContainer}>
          {hasSaveButton ? (
            <div className={styles.saveBtnContainer}>
              <ExtraTab
                onClick={handleFormSubmit}
                text={saveButtonText || t('global.save')}
                icon={<SaveIcon />}
                disabled={saveButtonDisabled}
              />
            </div>
          ) : null}
          {extraButton && <div>{extraButton}</div>}
        </div>
      ) : null}
    </>
  );
};

export default FormComponent;
